// extracted by mini-css-extract-plugin
export default {"container":"Products_container__uEasG","products":"Products_products__g6mVw","menu":"Products_menu__-wZtx","list":"Products_list__9Rnfp","product":"Products_product__cJdDj"};